import { render, staticRenderFns } from "./SubjectForm.vue?vue&type=template&id=6a1dbf32&scoped=true&"
import script from "./SubjectForm.vue?vue&type=script&lang=js&"
export * from "./SubjectForm.vue?vue&type=script&lang=js&"
import style0 from "./SubjectForm.vue?vue&type=style&index=0&id=6a1dbf32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1dbf32",
  null
  
)

export default component.exports